/** A Clerk organization id, the only shape `?org=` may take. The route's
 * search validation drops anything else, and the gate checks again: the root
 * route has no validateSearch, so TanStack still hands a child route the raw
 * value its own validator left out.
 *
 * Its own module so a file that only checks the shape (the card verification
 * return, #2602) does not pull BillingOrgLinkGate's component in with it. */
export const BILLING_ORG_REF_PATTERN = /^org_[A-Za-z0-9]+$/;
